export const getDifferenceInMinutes = (date1: Date, date2: Date): number => {
    const diffInMilliseconds = Math.abs(date2.getTime() - date1.getTime())
    const diffInMinutes = diffInMilliseconds / (1000 * 60)
    return diffInMinutes
}

export function formatTime(minutes: number, seconds: number): string {
    return `${minutes}:${seconds.toString().padStart(2, '0')}`
}
